import _ from 'lodash'
import Base from '@/resources/Base'
import { getTimestampAgeSeconds } from '@/utilities/datetime.helper'
// import { encapsulateLongStrings } from "@/utilities/string.helper";

export default class Recommendation extends Base {
  constructor (uuid = null, attributes = {}, options = {}) {
    super(uuid, attributes, options)
    this.actionMap = []
    this.latestAction = {
      status: undefined,
      action: this.action,
      actionType: this.action ? this.action.split('@@@')[0].toLowerCase() : '',
      error: undefined
    }
  }

  get iocHashIndex () {
    return this.iocHash + '-' + this.index
  }

  get name () {
    return this.description
  }

  get type () {
    return this.action.split('@@@')[0]
  }

  /**
   * Convert map to list, sort by desc time so latest action is first
   * @param {*} actionMap
   */
  setActionMap (actionMap) {
    if (actionMap) {
      for (let actionHash in actionMap) {
        if (this.index === actionMap[actionHash].recoIdx) {
          this.actionMap.push(_.extend(actionMap[actionHash], { actionHash: actionHash }))
        }
      }
      this.actionMap.sort((a, b) => {
        return b.timestamp - a.timestamp
      })
    }
  }

  parseExecutedActions (markedIocs) {
    // apply latest action status, type, error
    let latestAction = this.latestAction
    let actions = _.filter(this.actionMap, item => {
      return this.index === item.recoIdx
    })
    if (actions[0]) {
      let status = 'pending'
      if (actions[0].result) {
        if (actions[0].result.error) {
          status = 'failed'
          latestAction.error = actions[0].result.error
        } else {
          status = 'executed'
        }
      }
      if (status === 'pending') {
        if (getTimestampAgeSeconds(actions[0].timestamp) > 30) {
          status = 'failed'
        }
      }
      if (actions[0].actionString === 'DISMISSED' || actions[0].actionString === 'DONE') {
        latestAction.status = actions[0].actionString.toLowerCase()
      } else if (actions[0].actionString === 'UNDO') {
        latestAction.status = undefined
      } else {
        latestAction.status = status
        latestAction.action = actions[0].actionString
        latestAction.actionType = actions[0].actionString.split('@@@')[0].toLowerCase()
      }
    }

    // parse marked iocs
    markedIocs.forEach(ioc => {
      if (this.iocHash === ioc.ioc_hash && this.index === ioc.index) {
        latestAction.status = ioc.state.toLowerCase()
      }
    })
  }

  isStatus (status) {
    let latestAction = this.latestAction
    switch (status) {
      case 'manual':
        return latestAction.action == null
      case 'reversible':
        if (this.valid && this.compatibleAgent && latestAction.status === 'executed') {
          switch (latestAction.actionType) {
            case 'block-network':
            case 'unblock-network':
            case 'quarantine-file':
            case 'restore-file':
              return true
          }
        }
        return false
      case 'reversed':
        if (this.valid && this.compatibleAgent && latestAction.status === 'executed') {
          switch (latestAction.actionType) {
            case 'block-network':
            case 'quarantine-file':
              return true
          }
        }
        return false
      case 'incompatible':
        return !this.compatibleAgent
      case 'invalid':
        return (
          !this.valid &&
          latestAction.status !== 'executed' &&
          latestAction.status !== 'dismissed' &&
          latestAction.status !== 'done' &&
          latestAction.action !== null
        )
      case 'default':
        return (
          (this.valid && latestAction.status === undefined) ||
          (latestAction.action == null && latestAction.status === null)
        )
      default:
        return latestAction.status === status
    }
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/Recommendation.js